module.exports = __webpack_public_path__ + "img/form.b12e1381.svg";